module.exports = __webpack_public_path__ + "img/Stadtgeflüster.d8f38855.jpg";